import keycloak from 'auth/keycloak-api/keycloak';
import EnvironmentVariables from 'helpers/EnvVariables';

import { KidsFirstKeycloakTokenParsed } from 'common/tokenTypes';
import { sendRequest } from 'services/api';

import { TNewsletterSubscribe, TUser, TUserInsert, TUserUpdate } from './models';

export const USER_API_URL = `${EnvironmentVariables.configFor('USERS_API')}/user`;
export const NEWSLETTER_API_URL = `${EnvironmentVariables.configFor('USERS_API')}/newsletter`;

export const headers = () => ({
  'Content-Type': 'application/json',
});

export interface ISearchParams {
  pageIndex?: number;
  pageSize?: number;
  match?: string;
  sort?: string;
  roles?: string;
  interests?: string;
}

const fetch = () =>
  sendRequest<TUser>({
    method: 'GET',
    url: USER_API_URL,
    headers: headers(),
  });

const create = (body?: Omit<TUserInsert, 'keycloak_id'>) => {
  const tokenParsed = keycloak.tokenParsed as KidsFirstKeycloakTokenParsed;
  return sendRequest<TUser>({
    method: 'POST',
    url: USER_API_URL,
    headers: headers(),
    data: {
      ...body,
      email: body?.email || tokenParsed.email || tokenParsed.identity_provider_identity,
      first_name: body?.first_name || tokenParsed.given_name,
      last_name: body?.last_name || tokenParsed.family_name,
    },
  });
};

const search = ({ pageIndex = 0, pageSize = 15, match, sort, roles, interests }: ISearchParams) =>
  sendRequest<{
    users: TUser[];
    total: number;
    allActiveUsersTotal: number;
  }>({
    method: 'GET',
    url: `${USER_API_URL}/search`,
    headers: headers(),
    params: {
      pageIndex: pageIndex,
      pageSize: pageSize,
      match,
      sort,
      roles,
      areasOfInterest: interests,
    },
  });

const update = (body: TUserUpdate) =>
  sendRequest<TUser>({
    method: 'PUT',
    url: USER_API_URL,
    headers: headers(),
    data: body,
  });

const deleteUser = () =>
  sendRequest<void>({
    method: 'DELETE',
    url: USER_API_URL,
    headers: headers(),
  });

const subscribeNewsletter = (body: TNewsletterSubscribe) =>
  sendRequest<TUser>({
    method: 'PUT',
    url: `${NEWSLETTER_API_URL}/subscribe`,
    headers: headers(),
    data: body,
  });

export const UserApi = {
  search,
  fetch,
  create,
  update,
  deleteUser,
  subscribeNewsletter,
};
